import React from 'react'

function Mac() {
  return (
    <div>
    <br/> <br/>
    <h1>thes is mac page</h1>
    </div>
  )
}

export default Mac